export default "__VITE_ASSET__HQwtpOFY__"